import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { ChevronRight } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'

export interface SettingItemProps {
  title: string
  description?: string
  icon: React.ComponentType<{ size?: number; color?: string }>
  onPress?: () => void
  iconColor?: string
  iconBgColor?: string
  circleSize?: number
  iconSize?: number
}

export const SettingItem: React.FC<SettingItemProps> = ({
  title,
  description,
  icon: IconComponent,
  onPress,
  iconColor,
  iconBgColor,
  circleSize,
  iconSize,
}) => {
  const theme = useTheme()
  // console.log(iconBgColor)
  // console.log({
  //   backgroundColor: iconBgColor || theme.colors.background.secondaryGray,
  // })
  return (
    <BaseView
      row
      align="center"
      gap={12}
      px={12}
      py={12}
      rounded={28}
      bgColor="background.cardItemRoot"
      style={{
        cursor: onPress ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
      }}
      className="hover:opacity-80"
      onClick={onPress}
    >
      {/* Icon Container */}
      <BaseView
        circle
        circleSize={48}
        center
        style={{
          background: iconBgColor || theme.colors.background.secondaryGray,
        }}
      >
        <IconComponent
          size={iconSize || 24}
          color={
            iconColor ||
            theme.colors.icon?.activeIconTabNav ||
            theme.colors.label.default
          }
        />
      </BaseView>

      {/* Content */}
      <BaseView flex={1} gap={2}>
        <BaseText fontSize={16} fontFamily="semibold" color="label.default">
          {title}
        </BaseText>

        {description && (
          <BaseText
            fontSize={12}
            fontFamily="medium"
            color="label.description"
            style={{ lineHeight: '20px' }}
          >
            {description}
          </BaseText>
        )}
      </BaseView>

      {/* Chevron Right */}
      {onPress && (
        <ChevronRight size={26} color={theme.colors.label.description} />
      )}
    </BaseView>
  )
}
